<template>

    <section class="section-servicios nunito" :style="{
        '--marginY': marginY,
        '--marginT': marginT,
        '--marginB': marginB,
        '--backgroundColor': backgroundColor
    }">
        <div class="content">
            <div class="top" v-if="!isServicePage">
                <h2 class="title" v-text="title"></h2>
                <p v-text="description"></p>
            </div>
            <div class="row">

                <div class="options">
                    <h5 class="category">Categorías</h5>
                    <ul>
                        <li v-for="item in uniqueCategories" :key="item">
                            <button @click="showCategory(item.category)"
                                :class="item.category == categoryActive ? 'active' : ''">
                                <div>
                                    <i :class="item.icon"></i>
                                    <span>{{ item.category }}</span>
                                </div>
                                <i class="fa-solid fa-chevron-right"></i>
                            </button>
                        </li>
                    </ul>
                </div>
                <div class="info">
                    <div class="servicex" v-for="item in filteredServices" :key="item.id">
                        <div class="header">
                            <div class="join">

                                <i class="far fa-check-circle icon-check"></i>
                                <h4 class="title">{{ item.title }}</h4>
                            </div>
                        </div>
                        <div class="down">
                            <details name="services">
                                <summary>
                                    <div class="healthInsurance">

                                        Saber mas
                                    </div>
                                    <div class="showMore">
                                        <i class="fas fa-chevron-down"></i>
                                    </div>
                                </summary>
                                <p>{{ item.description }}</p>
                            </details>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import servicesData from '../data/services.json';

export default {
    name: 'previewPage2Component',
    props: {
        title: {
            type: String,
            default: 'Titulo aquí'
        },
        description: {
            type: String
        },
        marginY: {
            type: String,
        },
        marginT: {
            type: String
        },
        marginB: {
            type: String
        },
        backgroundColor: {
            type: String
        }
    },
    data() {
        return {
            servicesData,
            showMore: '',
            isServicePage: false,
            categoryActive: 'Redes Sociales',
        };
    },
    created() {
        if (this.$route.path === '/services') {
            this.isServicePage = true;
        }
    },
    computed: {
        uniqueCategories() {
            const categories = {};
            this.servicesData.forEach(item => {
                if (!categories[item.category]) {
                    categories[item.category] = { category: item.category, icon: item.icon };
                }
            });
            return Object.values(categories);
        },

        filteredServices() {
    const category = this.servicesData.find(cat => cat.category === this.categoryActive);
    return category ? category.services : [];
}

    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    },
    methods: {
        showCategory(category) {
            this.categoryActive = category;
        },
        handleClickOutside(event) {
            const detailsElements = this.$el.querySelectorAll('details');
            detailsElements.forEach(details => {
                if (!details.contains(event.target)) {
                    details.removeAttribute('open');
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
$bg_hover_servicex: #1f2122;
$bg_servicex: #1f2122;

body.dark-theme .section-servicios {
    background: transparent;

    .content {
        .top {
            color: rgb(246, 246, 246);
        }

        .row {
            .options {
                .category {
                    color: #f08908;
                }

                ul {
                    li {
                        button {
                            color: rgb(159, 157, 157);

                            &.active {
                                background: #f08908;
                                color: white;

                                &:hover {
                                    background: #f08908;
                                    color: white;
                                }
                            }

                            &:hover {
                                background: #2b2a2a;
                                color: rgb(243, 240, 240);
                            }
                        }
                    }
                }
            }

            .info {
                .servicex {
                    background: $bg_servicex;
                    border-color: $bg_servicex;
                    transition: background 0.5s;

                    &:hover {
                        background: $bg_hover_servicex;
                        transition: background 0.5s;

                        .down {
                            details {
                                p {
                                    background: $bg_hover_servicex;
                                    transition: background 0.5s;
                                }
                            }
                        }

                    }

                    .header {
                        .join {
                            .title {
                                color: #ffffff;
                            }

                            i {
                                color: #dbd4d4;

                            }
                        }
                    }

                    .down {
                        // color:#1b995c;
                        color: #ccd6d1e0;

                        details {
                            summary {
                                .showMore {
                                    color: white;
                                }
                            }

                            p {
                                background: $bg_servicex;
                                border: $bg_servicex;
                                color: rgba(255, 255, 255, 0.956);
                                transition: background 0.5s;
                            }
                        }
                    }
                }
            }
        }
    }
}

.section-servicios {
    * {
        // border: 1px solid;
    }

    width: 100%;
    background: var(--backgroundColor);
    padding: 0px 20px;
    margin: var(--marginY) 0;
    margin-bottom: var(--marginB);
    margin-top: var(--marginT);

    .content {
        width: 100%;
        max-width: 1280px;
        margin: 0 auto;


        .top {
            max-width: 600px;
            width: 100%;
            text-align: center;
            margin: 0 auto 50px auto;

            .title {
                font-size: 2.8rem;

                @media (max-width: 768px) {
                    font-size: 2rem;
                }

                @media (max-width: 480px) {
                    font-size: 1.7rem;
                }

            }
        }

        .row {
            width: 90%;
            margin: 0 auto;
            display: flex;
            flex-wrap: wrap;
            // flex-direction: row-reverse;
            gap: 40px;

            @media (max-width: 768px) {
                gap: 20px;
                width: 95%;

            }

            @media (max-width: 980px) {
                width: 90%;
            }

            .options {
                // border-right:2px solid #ccc;
                max-width: 300px;
                width: 100%;

                &::-webkit-scrollbar {
                    background-color: transparent;
                    height: 10px;
                }

                &::-webkit-scrollbar-thumb {
                    background: rgb(91, 91, 91);
                    border-radius: 20px;
                }

                @media (max-width: 768px) {
                    max-width: 100%;
                    flex-wrap: nowrap;
                    padding-bottom: 10px;
                    display: flex;
                    gap: 20px;
                    overflow-x: auto;
                    align-items: center;
                }

                .category {
                    font-size: 1.8rem;
                    margin-bottom: 20px;

                    @media (max-width: 768px) {
                        font-size: 1.2rem;
                        display: none;
                        margin: 0;
                    }
                }

                ul {
                    display: flex;
                    width: 100%;
                    flex-wrap: wrap;
                    gap: 10px;

                    @media (max-width: 768px) {
                        flex-wrap: nowrap;
                        gap: 20px;
                    }

                    li {
                        list-style: none;
                        width: 100%;

                        button {
                            width: 100%;
                            padding: 10px;
                            justify-content: space-between;
                            display: flex;
                            align-items: center;
                            background: transparent;
                            font-size: 1.2rem;
                            border: none;
                            border-radius: 10px;

                            @media (max-width: 768px) {
                                font-size: 1.1rem;
                            text-wrap: nowrap;

                            }

                            @media (max-width: 480px) {
                                font-size: 0.9rem;
                            }

                            div {
                                display: flex;
                                gap: 10px;
                                align-items: center;

                                i {
                                    display: block;
                                }
                            }

                            i {
                                @media (max-width: 768px) {
                                    display: none;
                                }

                            }

                            &.active {
                                background: #1b1b1c;
                                color: white;

                                &:hover {
                                    cursor: pointer;
                                    background: #1b1b1c;
                                    color: white;
                                }
                            }

                            &:hover {
                                background: rgb(236, 236, 236);
                                color: rgb(24, 23, 23);
                                cursor: pointer;
                            }
                        }
                    }
                }

            }

            .info {
                flex: 1;
                display: flex;
                flex-wrap: wrap;
                gap: 30px;
                height: fit-content;


                .servicex {
                    display: flex;
                    gap: 20px;
                    flex-wrap: wrap;
                    height: auto;
                    flex: 1;
                    min-width: 300px;
                    // width: calc(50% - 15px);
                    border: 1px solid #333;
                    border-radius: 20px;


                    @media (max-width: 1050px) {
                        width: 100%
                    }

                    @media (max-width: 768px) {
                        width: calc(50% - 15px);
                    }

                    @media (max-width: 740px) {
                        width: 100%;
                    }

                    .header {
                        display: flex;
                        align-items: flex-start;
                        justify-content: space-between;
                        width: 100%;
                        padding: 20px 20px 0 20px;


                        .join {
                            display: flex;
                            gap: 10px;

                            .title {
                                font-size: 1.2rem;

                                @media (max-width: 768px) {
                                    font-size: 1.1rem;
                                }
                            }

                            i.icon-check {
                                font-size: 2rem;

                                @media (max-width: 768px) {
                                    font-size: 1.5rem;
                                }
                            }
                        }

                        i.icon-healthInsurance {
                            font-size: 2rem;
                            color: rgb(176, 15, 15);

                            @media (max-width: 768px) {
                                font-size: 1.5rem;
                            }

                            &.apply {
                                color: #1b995c;
                            }
                        }
                    }

                    .down {
                        width: 100%;
                        font-weight: bold;

                        details {
                            width: 100%;
                            position: relative;
                            padding: 20px;


                            summary {
                                justify-content: space-between;
                                display: flex;
                                align-items: center;
                                width: 100%;
                                cursor: pointer;

                                .showMore {
                                    background: transparent;
                                    border: none;
                                    font-size: 1.8rem;
                                    cursor: pointer;
                                    transition: transform 0.3s;

                                    @media (max-width: 768px) {
                                        font-size: 1.5rem;
                                    }

                                }
                            }

                            &[open] {
                                .showMore {
                                    transform: rotate(180deg);
                                    transition: transform 0.2s;
                                }
                            }

                            p {
                                background: white;
                                position: absolute;
                                width: calc(100% + 1.5px);
                                padding: 20px;
                                left: -0.5px;
                                top: 55px;
                                border: 1px solid #333;
                                border-top: 0;
                                font-weight: 600;
                                z-index: 3;
                                font-size: 1.2rem;
                                border-bottom-left-radius: 20px;
                                border-bottom-right-radius: 20px;
                                letter-spacing: 0.02em;

                                @media (max-width: 768px) {
                                    font-size: 1.1rem;
                                }
                            }
                        }

                    }




                }
            }
        }
    }
}
</style>
